<template>
  <div 
    class="help-container p-2"
    :style="{
      border: '1px solid #d1d5db',
      borderRadius: '0.5rem',
      backgroundColor: 'white'
    }"
  >
    <!-- Search Header -->
    <div class="bg-neutral-100 px-2 py-1.5 rounded-lg flex items-center gap-2 mb-2">
      <ClSearchMagnifyingGlass class="h-4 w-4 text-neutral-500" />
      <span class="text-neutral-500 text-sm font-semibold">Nach Hilfe suchen</span>
    </div>
    
    <!-- Suggestion List -->
    <div class="bg-white">
      <button
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
        class="w-full px-2 py-3 text-xs text-left transition-all duration-200 flex items-center justify-between cursor-pointer hover:bg-neutral-50 hover:rounded-md"
        :style="{ 
          borderBottom: index < options.length - 1 ? '1px solid #f3f4f6' : 'none'
        }"
      >
        <span class="text-gray-700">{{ option.text }}</span>
        <AkChevronRightSmall class="h-4 w-4 text-gray-400" />
      </button>
    </div>
  </div>
</template>

<script>
import { ClSearchMagnifyingGlass } from '@kalimahapps/vue-icons';
import { AkChevronRightSmall } from '@kalimahapps/vue-icons';

export default {
  name: "HelpSearchContainer",
  components: {
    ClSearchMagnifyingGlass,
    AkChevronRightSmall
  },
  props: {
    title: {
      type: String,
      default: "Quick Support",
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ["select-option", "navigate-to-faq"],
  methods: {
    async selectOption(option) {
      console.log("🎯 HelpSearchContainer: Option selected:", option);

      // Check if this option has an FAQ linked
      if (option.faqId) {
        console.log("📋 FAQ option selected, loading FAQ:", option.faqId);
        
        try {
          // ✅ FIXED: Correct import syntax (removed 'this.')
          const { fetchFAQById } = await import("../lib/appwriteFaq");

          // Fetch the complete FAQ data
          const faqData = await fetchFAQById(option.faqId);

          if (faqData) {
            console.log("✅ FAQ data loaded:", faqData);

            // Emit FAQ navigation event with complete data
            this.$emit("navigate-to-faq", {
              faqData: {
                $id: faqData.$id,
                question: faqData.question,
                answer: faqData.answer,
                category: faqData.category,
              },
              category: faqData.category,
              directToFaq: true,
              source: "help-search-container",
            });

            console.log("🎯 FAQ navigation event emitted from HelpSearchContainer");
            return; // Don't emit select-option for FAQ items
          } else {
            console.error("❌ Failed to load FAQ data");
            // Fall back to regular behavior
          }
        } catch (error) {
          console.error("❌ Error loading FAQ:", error);
          // Fall back to regular behavior
        }
      }

      // Regular option selection (non-FAQ or fallback)
      this.$emit("select-option", {
        text: option.text,
        target: option.target || "ChatScreen",
        faqId: option.faqId || null,
        originalOption: option,
      });
    },
  },
};
</script>